<template>
  <div class="unmatched-card blank umm-cardback" :style="backgroundImage">
    <b-form-input
      v-if="isEditable"
      placeholder="Image URL for card back"
      trim
      :value="value"
      @input="$emit('input', $event)"
    >
    </b-form-input>
  </div>
</template>

<script>
export default {
  name: "UnmatchedCardBack",
  props: {
    value: {},
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    backgroundImage() {
      if (this.value) {
        return {
          "background-image": `url(${this.value})`,
          "background-repeat": "no-repeat",
          "background-size": "cover",
          "background-position": "center",
        };
      }
      return {};
    },
  },
};
</script>

<style lang="less">
.umm-cardback {
  input {
    font-family: var(--font-family-sans-serif);
    visibility: hidden;
    &:focus {
      visibility: visible;
    }
  }

  &:hover {
    // box-shadow: @editable-glow;
  }

  &:hover input {
    visibility: visible;
  }
}
</style>
